import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardSettingsRoute: InvariantJiraRoute = {
	name: 'rapidboard-board-settings',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/settings/:config',
	query: ['from-backlog?'],
};
